export default __webpack_public_path__ + "static/media/ethereum-icon.79cafb0b.svg";